import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '../ui/Icon';
export function WhatsAppButton() {
  return <motion.a href="https://wa.link/paqueteblackfriday" target="_blank" rel="noopener noreferrer" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1,
    duration: 0.5,
    type: 'spring'
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.95
  }} className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BA5A] text-white p-4 rounded-full shadow-2xl transition-colors duration-300 group" aria-label="Chat on WhatsApp" data-id="element-279">
      <motion.div animate={{
      scale: [1, 1.2, 1]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      repeatType: 'loop'
    }} className="absolute inset-0 bg-[#25D366] rounded-full opacity-30" data-id="element-280" />
      <Icon name="message-circle" size={28} className="relative z-10" data-id="element-281" />

      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-282">
        <div className="bg-gray-900 text-white text-sm font-medium px-3 py-2 rounded-lg whitespace-nowrap shadow-lg" data-id="element-283">
          ¿Tienes preguntas? Chatea con nosotros
          <div className="absolute top-full right-4 w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-gray-900" data-id="element-284" />
        </div>
      </div>
    </motion.a>;
}